import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import base_url from './api/Config';
import TopBar from './component/TopBar';

function PanVerifecation() {
  const [pan, setPan] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const id = new URLSearchParams(location.search).get('id');

  const handlePanChange = (e) => {
    let input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    let formatted = input.slice(0, 5).replace(/[^A-Z]/g, '');
    formatted += input.slice(5, 9).replace(/[^0-9]/g, '');
    formatted += input.slice(9, 10).replace(/[^A-Z]/g, '');
    if (formatted.length <= 10) setPan(formatted);
  };

  const handleSubmit = async () => {
    if (pan.length !== 10 || !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
      setErrorMessage('Please enter a valid PAN number (e.g. ABCDE1234F).');
      setErrorModal(true);
      return;
    }
    if (!isChecked) {
      setErrorMessage('Please give your consent by checking the box.');
      setErrorModal(true);
      return;
    }
    setIsLoading(true);
    try {
      const res = await fetch(`${base_url}/api/pan/allPanDetails?applicationId=${id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pan }),
      });
      const data = await res.json();
      if (res.ok) {
        if (data.data?.statusCodeValue === 400 && data.data?.body?.includes('PAN number already exists')) {
          setErrorMessage('This PAN number is already registered.');
          setErrorModal(true);
        } else {
          navigate(`/Address?applicationId=${id}&customerId=${id}`);
        }
      } else {
        setErrorMessage(data.message || 'Error verifying PAN. Please try again.');
        setErrorModal(true);
      }
    } catch {
      setErrorMessage('Something went wrong. Please try again.');
      setErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-page">
      <TopBar title="PAN Verification" backPath={`/Permission?id=${id}`} />
      {isLoading && <div className="loader-overlay"><div className="spinner-border text-light" /></div>}

      <div className="app-content">
        <div className="app-card" style={{ textAlign: 'center' }}>
          <img src="/assets/images/PanCard.png" alt="PAN Card" style={{ width: 120, marginBottom: 16 }} />
          <p className="section-title">Enter PAN Details</p>

          <div className="field-group" style={{ textAlign: 'left' }}>
            <label className="field-label">PAN Number <span className="field-star">*</span></label>
            <input
              className="field-input"
              value={pan}
              onChange={handlePanChange}
              maxLength={10}
              placeholder="ABCDE1234F"
              style={{ textTransform: 'uppercase', letterSpacing: 4, textAlign: 'center', fontSize: 18 }}
            />
          </div>

          <div className="check-row" style={{ marginTop: 12 }}>
            <input type="checkbox" checked={isChecked} onChange={e => setIsChecked(e.target.checked)} />
            <label>I consent to verifying my PAN card for loan assessment.</label>
          </div>
        </div>

        <button className="btn-primary-app" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Verifying...' : 'Verify PAN'}
        </button>
      </div>

      <Modal show={errorModal} onHide={() => setErrorModal(false)} centered>
        <Modal.Body className="text-center p-4">
          <strong>{errorMessage}</strong>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setErrorModal(false)}>Close</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PanVerifecation;
